"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.split_trade = exports.split_I_or_E = exports.arrangeTrade = void 0;
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const d3 = __importStar(require("d3"));
const AFMSankeyMenu_1 = require("./AFMSankeyMenu");
const arrangeTrade = (data, scale) => {
    const { nodes, links } = data;
    let import_nodes = [];
    if ('Niveau Echanges' in data.nodeTags) {
        const level_selected = Object.values(data.nodeTags['Niveau Echanges'].tags).filter(tag => tag.selected)[0].name;
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) || n.tags['Type de noeud'][0] == 'échange').filter(n => {
            if (!('dimensions' in n)) {
                return false;
            }
            if (!('Niveau Echanges' in n.dimensions)) {
                return false;
            }
            if (!('Niveau Echanges' in n.tags)) {
                return false;
            }
            const selected = n.tags['Niveau Echanges'].filter(tag => tag.includes(level_selected)).length > 0;
            if (!selected) {
                return false;
            }
            if (n.outputLinksId.length == 0) {
                return false;
            }
            return true;
        });
        import_nodes = import_nodes.concat(res);
    }
    else {
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) && n.tags['Type de noeud'][0] == 'échange' && n.outputLinksId.length > 0);
        import_nodes = import_nodes.concat(res);
    }
    import_nodes = [...new Set(import_nodes)];
    let export_nodes = [];
    if ('Niveau Echanges' in data.nodeTags) {
        const level_selected = Object.values(data.nodeTags['Niveau Echanges'].tags).filter(tag => tag.selected)[0].name;
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) && n.tags['Type de noeud'][0] == 'échange').filter(n => {
            if (!('dimensions' in n)) {
                return false;
            }
            if (!('Niveau Echanges' in n.dimensions)) {
                return false;
            }
            if (!('Niveau Echanges' in n.tags)) {
                return false;
            }
            const selected = n.tags['Niveau Echanges'].filter(tag => tag.includes(level_selected)).length > 0;
            if (!selected) {
                return false;
            }
            if (n.inputLinksId.length == 0) {
                return false;
            }
            return true;
        });
        export_nodes = export_nodes.concat(res);
    }
    else {
        const res = Object.values(nodes).filter(n => (('Type de noeud' in n.tags)) && n.tags['Type de noeud'][0] == 'échange' && n.inputLinksId.length);
        export_nodes = export_nodes.concat(res);
    }
    export_nodes = [...new Set(export_nodes)];
    const import_nodes_close = import_nodes.filter(n => n.trade_close);
    const export_nodes_close = export_nodes.filter(n => n.trade_close);
    import_nodes_close.forEach(node => {
        const output_link = links[node.outputLinksId[0]];
        if (!output_link) {
            return;
        }
        //const output_node = nodes[output_link.idTarget]
        node.position = 'relative';
        node.x = -data.trade_close_hspace;
        node.y = -data.trade_close_vspace;
        node.label_visible = false;
        node.shape_visible = false;
        node.y_label = node.y + +node.node_width;
        //output_link.label_position = 'frozen'
        output_link.orientation = 'vh';
        output_link.label_position = 'end';
        output_link.label_on_path = true;
        //output_link.text_color = 'white'
        output_link.label_visible = true;
    });
    export_nodes_close.forEach((node) => {
        const input_link = links[node.inputLinksId[0]];
        node.position = 'relative';
        node.x = data.trade_close_hspace;
        node.y = data.trade_close_vspace;
        node.label_visible = false;
        node.shape_visible = false;
        node.y_label = node.y + 10;
        input_link.orientation = 'hv';
        input_link.label_visible = true;
        input_link.label_position = 'beginning';
        input_link.label_on_path = true;
        //input_link.text_color = 'white'
        input_link.label_visible = true;
        // d3.select('#ggg_'+node.idNode + ' text')
        //   .attr('text-anchor', 'left')
    });
    // Trade at the top and bottom
    const import_nodes_outside = import_nodes.filter(n => !n.trade_close);
    const export_nodes_outside = export_nodes.filter(n => !n.trade_close);
    const nb_import = {};
    const nb_export = {};
    let prev_y = {};
    const link_x = {};
    let max_vertical_offset = 0;
    const compute_offset = (node) => {
        if (!node.y) {
            return;
        }
        if ('Type de noeud' in node.tags && node.tags['Type de noeud'] && node.tags['Type de noeud'][0] == 'échange' && node.inputLinksId.length > 0) {
            return;
        }
        max_vertical_offset = Math.max(node.y, max_vertical_offset);
    };
    Object.values(nodes).filter(n => n.node_visible).forEach(compute_offset);
    max_vertical_offset = max_vertical_offset + 200;
    import_nodes_outside.forEach((node) => {
        node.position = 'absolute';
        node.label_visible = true;
        node.shape_visible = false;
        const output_link = links[node.outputLinksId[0]];
        output_link.text_color = SankeyUtils_1.node_color(nodes[output_link.idTarget], data);
        // x position
        const target_node = nodes[output_link.idTarget];
        const x = Math.round(target_node.x / data.h_space) * data.h_space - data.trade_hspace;
        const xstr = x.toString();
        if (!(xstr in nb_import)) {
            nb_import[xstr] = 0;
        }
        nb_import[xstr] = nb_import[xstr] + 1;
        // node x position
        node.x = x;
        // node label x position
        const d3_node = d3.select('#ggg_' + node.idNode + ' text').node();
        if (!d3_node) {
            return;
        }
        const l = d3_node.getComputedTextLength();
        //node.x_label = node.node_width - l - 2
        // link label x position preprocessing
        const node_x_str = x.toString();
        if (!(node_x_str in link_x)) {
            link_x[node_x_str] = node.x - l;
        }
        const html_node = d3.select('#' + node.outputLinksId[0] + '_text').node();
        if (!html_node) {
            return;
        }
        const link_value_length = html_node.getComputedTextLength();
        link_x[node_x_str] = Math.min(node.x - l - link_value_length + node.node_width - 2, link_x[node_x_str]);
        // y position
        if (!(xstr in prev_y)) {
            prev_y[xstr] = 20;
        }
        const h = d3.select('#ggg_' + node.idNode + ' text').node().getBBox().height;
        const y = prev_y[xstr];
        prev_y[xstr] = y + Math.max(scale(SankeyUtils_1.getLinkValue(data, output_link.idLink).value), h) + 5;
        // node y position
        node.y = y;
        node.display_style.label_box_width = 300;
        // node label y position
        node.y_label = undefined; //scale(getLinkValue(data,output_link.idLink).value)/2 + h/3
        node.x_label = undefined;
        output_link.y_label = node.y + scale(SankeyUtils_1.getLinkValue(data, output_link.idLink).value) / 2 - h / 2;
        node.display_style.label_horiz = 'left';
        node.display_style.label_vert = 'middle';
        node.node_width = 0;
        //node.display_style.label_color = node_color(nodes[output_link.idTarget],data)
    });
    Object.keys(nb_import).forEach(xstr => import_nodes.filter(n => n.x === +xstr).forEach((n, i) => {
        const left_shift = data.trade_left_shift - (i / nb_import[n.x]) * data.trade_max_shift;
        links[n.outputLinksId[0]].left_horiz_shift = left_shift;
        const right_shift = data.trade_right_shift - (i / nb_import[n.x]) * data.trade_max_shift;
        links[n.outputLinksId[0]].right_horiz_shift = right_shift;
    }));
    import_nodes_outside.forEach((node) => {
        const output_link = links[node.outputLinksId[0]];
        const node_x_str = node.x.toString();
        output_link.x_label = link_x[node_x_str];
        output_link.label_position = 'frozen';
        output_link.curvature = 1;
        output_link.orientation = 'hh';
        output_link.label_visible = true;
        if (SankeyUtils_1.getLinkValue(data, output_link.idLink).value === 0) {
            output_link.label_visible = false;
        }
        d3.select('#ggg_' + node.idNode + ' text')
            .selectAll('tspan')
            .attr('text-anchor', 'right');
    });
    prev_y = {};
    export_nodes_outside.forEach((node) => {
        node.position = 'absolute';
        node.label_visible = true;
        node.shape_visible = false;
        const input_link = links[node.inputLinksId[0]];
        input_link.text_color = SankeyUtils_1.node_color(nodes[input_link.idSource], data);
        const source_node = nodes[input_link.idSource];
        if (!source_node.display || !source_node.node_visible) {
            return;
        }
        const x = Math.round(source_node.x / data.h_space) * data.h_space + data.trade_hspace;
        const xstr = x.toString();
        if (!(xstr in nb_export)) {
            nb_export[xstr] = 0;
        }
        if (!(xstr in prev_y)) {
            prev_y[xstr] = max_vertical_offset;
        }
        nb_export[xstr] = nb_export[xstr] + 1;
        const d3_node = d3.select('#ggg_' + node.idNode + ' text').node();
        if (!d3_node) {
            return;
        }
        const l = d3_node.getComputedTextLength();
        const h = d3_node.getBBox().height;
        const y = prev_y[xstr];
        prev_y[xstr] = y + h;
        node.x = x;
        node.display_style.label_box_width = 300;
        node.y = y;
        node.display_style.label_horiz = 'right';
        node.display_style.label_vert = 'middle';
        node.node_width = 0;
        //node.display_style.label_color = node_color(nodes[input_link.idTarget],data)
        node.y_label = undefined; //scale(getLinkValue(data,input_link.idLink).value)/2 +h/4
        node.x_label = undefined;
        const node_x_str = x.toString();
        if (!(node_x_str in link_x)) {
            link_x[node_x_str] = node.x + l;
        }
        link_x[node_x_str] = Math.max(node.x + node.node_width / 2 + l, link_x[node_x_str]);
        input_link.y_label = node.y + scale(SankeyUtils_1.getLinkValue(data, input_link.idLink).value) / 2 - h / 2;
    });
    Object.keys(nb_export).forEach(xstr => export_nodes.filter(n => n.x === +xstr).forEach((n, i) => {
        const left_shift = data.trade_left_shift - (i / nb_export[n.x]) * data.trade_max_shift;
        links[n.inputLinksId[0]].left_horiz_shift = left_shift;
        const right_shift = data.trade_right_shift - (i / nb_export[n.x]) * data.trade_max_shift;
        links[n.inputLinksId[0]].right_horiz_shift = right_shift;
    }));
    export_nodes_outside.forEach((node) => {
        const input_link = links[node.inputLinksId[0]];
        if (!input_link) {
            return;
        }
        const node_x_str = node.x.toString();
        input_link.x_label = link_x[node_x_str];
        input_link.label_position = 'frozen';
        input_link.curvature = 1;
        input_link.orientation = 'hh';
        input_link.label_visible = true;
        d3.select('#ggg_' + node.idNode + ' text')
            .selectAll('tspan')
            .attr('text-anchor', 'left');
    });
};
exports.arrangeTrade = arrangeTrade;
// Fonctions d'individualisation des imports/exports
const split_I_or_E = (node, trade_name, importation, data) => {
    //const originalIdNode = node.idNode
    let tmp = [];
    let tmp1;
    if (importation) {
        tmp = node.outputLinksId.slice(); // clone
        tmp1 = 'idTarget';
    }
    else {
        tmp = node.inputLinksId.slice(); // clone
        tmp1 = 'idSource';
    }
    const listId = [];
    Object.keys(data.nodes).forEach(elt => listId.push(Number(elt.replace('node', ''))));
    let idNode = listId.length > 0 ? Math.max(...listId) + 1 : 0;
    tmp.forEach((idLink) => {
        const input_or_output_link = data.links[idLink];
        //input_or_output_link.visible = true
        const le_nom = data.nodes[input_or_output_link[tmp1]].name + ' - ' + trade_name;
        const x = 100;
        const y = 100;
        idNode = idNode + 1;
        data.nodes['node' + idNode] = AFMSankeyMenu_1.afm_default_node(data);
        data.nodes['node' + idNode]['name'] = le_nom;
        data.nodes['node' + idNode]['idNode'] = 'node' + idNode;
        data.nodes['node' + idNode]['tags'] = JSON.parse(JSON.stringify(node.tags));
        data.nodes['node' + idNode]['dimensions'] = Object.assign({}, node.dimensions);
        // name : le_nom,
        // idNode: 'node'+idNode,
        // shape : 'rect',
        // node_visible: false,
        // shape_visible :false,
        // label_visible: true,
        // display : true,
        // color:'grey',
        // colorParameter:'local',
        // style: 'default',
        // x:x, 
        // y:y,
        // inputLinksId:[],
        // outputLinksId:[],
        // tags: JSON.parse(JSON.stringify(node.tags)),
        // dimensions: {...node.dimensions},
        // trade_width: 50,
        // trade_height: 20,
        // trade_close: false,
        // colorTag : '',
        // colorSustainable: false,
        // show_value: false,
        // position: 'absolute',
        // hide_lone_node: false,
        // node_width: node.node_width,
        // node_height: node.node_height,
        // // iconName: 'none',
        // // iconColor: '#fff',
        // // iconRatio: 80,
        // // iconVisible: true,
        // not_to_scale:false,
        // not_to_scale_direction:'right',
        // display_style: {
        //   font_family: 'Cormorant',
        //   font_size: data.display_style.node_font_size,
        //   uppercase: data.display_style.sector_uppercase,
        //   bold: true,
        //   italic: false,
        //   // unit: data.display_style.unit,
        //   // filter: data.display_style.filter,
        //   // filter_label: data.display_style.filter_label,
        //   // global_curvature:data.display_style.global_curvature,
        //   // null_flux: data.display_style.null_flux,
        //   label_vert: 'milieu',
        //   label_horiz: 'droite',
        //   label_vert_valeur: 'milieu',
        //   label_horiz_valeur: 'droite',
        //   value_font_size: 14,
        //   label_box_width: 300,
        //   label_color: false
        // },
        //}
        const new_node = data.nodes['node' + idNode];
        if (importation) {
            const link = data.links[idLink];
            if (!link) {
                return;
            }
            link.idSource = new_node.idNode;
            const target_node = data.nodes[link.idTarget];
            Object.keys(target_node.dimensions).forEach(dim_key => {
                new_node.dimensions[dim_key] = JSON.parse(JSON.stringify(target_node.dimensions[dim_key]));
            });
            new_node.display = target_node.display;
            new_node.node_visible = target_node.node_visible;
            Object.keys(target_node.tags).forEach(tag_key => {
                if (tag_key === 'Type de noeud') {
                    return;
                }
                const tags = [...target_node.tags[tag_key]];
                if (tag_key in new_node.tags) {
                    new_node.tags[tag_key] = [...new Set(new_node.tags[tag_key].concat(tags))];
                }
                else {
                    new_node.tags[tag_key] = Object.keys(data.nodeTags[tag_key].tags);
                }
            });
            //new_node['tags']['Type de noeud'] = ['échange']
            new_node.outputLinksId.push(idLink);
        }
        else {
            const link = data.links[idLink];
            if (!link) {
                return;
            }
            link.idTarget = new_node.idNode;
            const source_node = data.nodes[link.idSource];
            Object.keys(source_node.dimensions).forEach(dim_key => {
                new_node.dimensions[dim_key] = JSON.parse(JSON.stringify(source_node.dimensions[dim_key]));
            });
            new_node.display = source_node.display;
            new_node.node_visible = source_node.node_visible;
            Object.keys(source_node.tags).forEach(tag_key => {
                if (tag_key === 'Type de noeud') {
                    return;
                }
                const tags = [...source_node.tags[tag_key]];
                if (tag_key in new_node.tags) {
                    new_node.tags[tag_key] = [...new Set(new_node.tags[tag_key].concat(tags))];
                }
                else {
                    new_node.tags[tag_key] = Object.keys(data.nodeTags[tag_key].tags);
                }
            });
            //new_node['tags']['Type de noeud'] = ['échange']
            new_node.inputLinksId.push(idLink);
        }
    });
    node.inputLinksId = [];
    node.outputLinksId = [];
};
exports.split_I_or_E = split_I_or_E;
const split_trade = (trade_name, data) => {
    const { nodes } = data;
    // e.g. "International"
    let node;
    Object.values(nodes).forEach(n => {
        if (n.name === trade_name) {
            node = n;
        }
    });
    if (node === undefined) {
        return -1;
    }
    if (node.outputLinksId.length > 0) { // Imports
        exports.split_I_or_E(node, trade_name, true, data);
        SankeyUtils_1.delete_node(data, node);
        Object.values(data.nodes).filter(n => n.name.includes(trade_name)).forEach(n => {
            if (n.outputLinksId.length == 0) {
                return;
            }
            const target_node = data.nodes[data.links[n.outputLinksId[0]].idTarget];
            Object.keys(target_node.dimensions).forEach(key => {
                if (!target_node.dimensions[key].parent_name) {
                    return;
                }
                const parent_name = data.nodes[target_node.dimensions[key].parent_name].name.split(' - ')[0] + ' - ' + trade_name;
                if (Object.values(data.nodes).filter(n => n.name === parent_name).length > 0) {
                    n.dimensions[key].parent_name = Object.values(data.nodes).filter(n => n.name === parent_name)[0].idNode;
                }
            });
        });
    }
    if (node.inputLinksId.length > 0) { // Exports
        exports.split_I_or_E(node, trade_name, false, data);
        SankeyUtils_1.delete_node(data, node);
        Object.values(data.nodes).filter(n => n.name.includes(trade_name)).forEach(n => {
            if (n.inputLinksId.length == 0) {
                return;
            }
            const source_node = data.nodes[data.links[n.inputLinksId[0]].idSource];
            Object.keys(source_node.dimensions).forEach(key => {
                if (!source_node.dimensions[key].parent_name) {
                    return;
                }
                const parent_name = data.nodes[source_node.dimensions[key].parent_name].name.split(' - ')[0] + ' - ' + trade_name;
                if (Object.values(data.nodes).filter(n => n.name === parent_name).length > 0) {
                    n.dimensions[key].parent_name = Object.values(data.nodes).filter(n => n.name === parent_name)[0].idNode;
                }
            });
        });
    }
    return node.idNode;
};
exports.split_trade = split_trade;
